import AbsenceUserArchiveSubordinate from 'features/absence/absenceUserArchiveSubordinate';

import { useTitle } from '../helpers';

/**
 * @page Absence user subordination archive page
 */

const AbsenceUserSubordinationArchivePage = () => {
  useTitle('Информация о неявке архива подчинённых');

  return (
    <div>
      <h3>Страница информации о неявке архива подчинённых</h3>
      <AbsenceUserArchiveSubordinate />
    </div>
  );
};

export default AbsenceUserSubordinationArchivePage;
